<template>
  <div
    :class="{ 'load load--fill': isLoading }"
    class="max-w-xl mx-auto"
  >
    <div v-if="!isLoading && membershipFee.hasOwnProperty('attributes')">
      <div class="flex flex-col">
        <div class="pb-4">
          <input
            id="require_membership_fee"
            v-model="requireMembershipFee"
            type="checkbox"
            name="require_membership_fee"
          >
          <label
            for="require_membership_fee"
            v-text="`Require ${membershipFee.attributes.title}`"
          />
        </div>
      </div>
      <div class="flex justify-center mb-6">
        <input
          class="btn"
          type="submit"
          :value="`Save ${membershipFee.attributes.title} Configuration`"
          @click.prevent="save"
        >
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ConfigureMembershipFee',
  props: {
    membershipUuid: {
      type: String,
      required: false,
      default: '',
    },
    context: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      query: '',
      isLoading: true,
      requireMembershipFee: true,
    }
  },
  computed: {
    ...mapState({
      membership: state => state.membership.membership,
      membershipFee: state => state.payments.membershipFee,
    }),
  },
  watch: {
    membershipUuid() {
      if (this.membershipUuid) {
        this.fetchMembership()
      }
    },
  },
  async mounted() {
    await this.$nextTick()

    this.getMembershipFee().then(() => {
      if (this.membershipUuid) {
        this.fetchMembership()
      } else {
        this.requireMembershipFee = true
      }
    }).then(() => {
      this.isLoading = false
    })
  },
  methods: {
    ...mapActions({
      updateMembership: 'membershipUpdateMembership',
      getMembership: 'membershipGetMembership',
      getMembershipFee: 'paymentsGetMembershipFee',
    }),
    save() {
      const data = { require_membership_fee: this.requireMembershipFee }

      this.updateMembership({
        membershipUuid: this.membershipUuid,
        data: data,
      }).then((response) => {
        if (response.data.status === 'success') {
          this.$store.commit('baseAddNotification', {
            type: 'success',
            text: 'Membership fee has been configured',
          })

          this.$emit('membershipFeeHasBeenConfigured')
        } else {
          this.$store.commit('baseAddNotification', {
            type: 'error',
            text: response.data.message,
            timeout: false,
          })
        }
      }).catch(() => {
        this.$store.commit('baseAddNotification', {
          type: 'error',
          text: 'An error has occurred.',
          timeout: false,
        })
      })
    },
    fetchMembership() {
      if (this.membershipUuid) {
        this.getMembership({ membershipUuid: this.membershipUuid }).then(() => {
          this.requireMembershipFee = this.membership.attributes.require_membership_fee
        })
      }
    },
  },
}
</script>
